import React from 'react';
import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { Edit, Upload } from '@mui/icons-material';

const CustomerInfoAlert = ({ customer, onEditInfo, onUploadImages, hasUnsavedImages }) => {
  const missingInfo = [];
  const missingImages = [];

  // Check missing personal info
  if (!customer?.full_name) missingInfo.push('Họ tên');
  if (!customer?.date_of_birth) missingInfo.push('Ngày sinh');
  if (!customer?.gender) missingInfo.push('Giới tính');
  if (!customer?.address) missingInfo.push('Địa chỉ');

  // Check missing CCCD images
  if (!customer?.front_cccd) missingImages.push('Ảnh CCCD mặt trước');
  if (!customer?.behind_cccd) missingImages.push('Ảnh CCCD mặt sau');

  const hasMissingInfo = missingInfo.length > 0;
  const hasMissingImages = missingImages.length > 0;

  if (!hasMissingInfo && !hasMissingImages) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      {hasMissingInfo && (
        <Alert 
          severity="warning" 
          sx={{ mb: 2 }}
          action={
            <Button
              color="inherit"
              size="small"
              startIcon={<Edit />}
              onClick={onEditInfo}
              sx={{ textTransform: 'none' }}
            >
              Cập nhật
            </Button>
          }
        >
          <AlertTitle>Thông tin cá nhân chưa đầy đủ</AlertTitle>
          Khách hàng chưa cung cấp: {missingInfo.join(', ')}. 
          Admin có thể cập nhật thông tin thủ công.
        </Alert>
      )}
      
      {hasMissingImages && (
        <Alert 
          severity="info"
          action={
            hasUnsavedImages ? (
              <Button
                color="inherit"
                size="small"
                onClick={onUploadImages}
                sx={{ textTransform: 'none' }}
              >
                Lưu ảnh
              </Button>
            ) : (
              <Button
                color="inherit"
                size="small"
                startIcon={<Upload />}
                sx={{ textTransform: 'none' }}
              >
                Upload ảnh
              </Button>
            )
          }
        >
          <AlertTitle>Ảnh CCCD chưa đầy đủ</AlertTitle>
          Khách hàng chưa upload: {missingImages.join(', ')}. 
          Admin có thể upload ảnh thủ công để hỗ trợ khách hàng.
        </Alert>
      )}
    </Box>
  );
};

export default CustomerInfoAlert;